import { type PropsWithChildren, type ReactNode } from 'react';

import type { SelectTriggerWidthOptionsType } from './types.js';
import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';

/**
 * @public
 */
export type SelectTriggerProps = PropsWithChildren &
  StylingProps &
  DataTestId &
  BehaviorTrackingProps & {
    /**
     * The placeholder text displayed in the Select.Trigger.
     */
    placeholder?: ReactNode;
    /**
     * The width of the Select.Trigger.
     * @defaultValue 'content'
     */
    width?: SelectTriggerWidthOptionsType;
  };

/**
 * @public
 */
export function SelectTrigger(props: SelectTriggerProps): null {
  return null;
}
